import React, { memo } from 'react';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import CustomSelect from "../../../components/common/select/Select";
import './InnovationRegionChannelSplit.styles.scss';

const InnovationRegionChannelSplit = memo(({
    isOpen,
    flagHandle,
    regionData,
    channelData,
    weeksArray,
    selectedWeek,
    handleWeekSelect,
    selectAllJCWeek,
    handleSelectAllJCWeek,
    handleRegionValueChange,
    handleChannelValueChange,
    handleRegionalChannelSplitSubmit,
    submittingRegionChannelSplitIsLoading,
    isDisabled
}) => {

    const handleClose = () => {
        flagHandle();
    };

    return (
        <div>
            < Modal
                className='modal'
                open={isOpen}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={isOpen} >

                    <div className='in-reg-cha-split-cont'>
                        <div className='reg-cha-split-heading' style={{ textAlign: 'center' }} >Region-Channel Split</div>

                        <div>
                            <input className='mr-16 mb-32' disabled={isDisabled} type="checkbox" checked={selectAllJCWeek} onChange={handleSelectAllJCWeek} />
                            <label onClick={handleSelectAllJCWeek}>Apply to all JC weeks</label>
                        </div>

                        <div className='df fdi-col mb-32 '>
                            <label className='in-filter-label'>JC Week</label>
                            <div className='f-s-13'>
                                <CustomSelect.MyCustomSelect
                                    placeholder={"Select JC Week"}
                                    allowSelectAll={false}
                                    isDisabled={selectAllJCWeek}
                                    isMulti={false}
                                    options={
                                        weeksArray &&
                                        weeksArray.map(item => ({
                                            label: `Week ${item}`,
                                            value: item
                                        }))
                                    }
                                    onChange={handleWeekSelect}
                                    value={
                                        weeksArray && selectedWeek ?
                                            weeksArray.filter(item =>
                                                selectedWeek === item
                                            )
                                                .map(item => ({
                                                    label: `Week ${item}`,
                                                    value: item
                                                }))
                                            :
                                            []
                                    }
                                />
                            </div>
                        </div>

                        <div className='reg-cha-split-heading' >Regions</div>

                        <div className='reg-cha-split-inp-lab-cont'>
                            {
                                regionData && selectedWeek &&
                                regionData[selectedWeek]?.map(item => (
                                    <div className='reg-cha-split-inp-lab' key={item.guid}>
                                        <label className='reg-cha-split-lab'>{item.Name}</label>
                                        <div style={{ marginTop: '14px' }}>
                                            <input 
                                            type="number" 
                                            className='reg-cha-split-inp'
                                            disabled={isDisabled}
                                            value={parseFloat(item.Value?.toFixed(2))}
                                            onChange={(e)=>handleRegionValueChange(e,item)}
                                            />
                                            <span>%</span>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                        <div className='reg-cha-split-heading' >Channels</div>

                        <div className='reg-cha-split-inp-lab-cont'>
                            {
                                channelData && selectedWeek &&
                                channelData[selectedWeek]?.map(item => (
                                    <div className='reg-cha-split-inp-lab' key={item.guid}>
                                        <label className='reg-cha-split-lab'>{item.Name}</label>
                                        <div style={{ marginTop: '14px' }}>
                                            <input 
                                            type="number" 
                                            className='reg-cha-split-inp'
                                            disabled={isDisabled}
                                            value={parseFloat(item.Value?.toFixed(2))}
                                            onChange={(e)=>handleChannelValueChange(e,item)}
                                            />
                                            <span>%</span>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                        <div style={{ textAlign: 'right' }}>
                            {
                                submittingRegionChannelSplitIsLoading ? 
                                <button className='in-btns in-primary-btn'>Loading...</button>
                                :
                                <button className='in-btns in-primary-btn' onClick={handleRegionalChannelSplitSubmit}>Save</button>
                            }
                        </div>
                    </div>

                </Fade>
            </Modal >
        </div >
    )
});


export default InnovationRegionChannelSplit;
